import * as Yup from 'yup';
import { AnyObject, TestContext, ValidationError } from 'yup';
import { validateSn } from './snValidationScheme';

export const originalValidationSchemeCustomer = (
  checkSn: (
    value: number,
    p: TestContext<AnyObject>
  ) => Promise<boolean | ValidationError>,
  produktionsdatumRequired: boolean,
  pinRequired: boolean
) =>
  Yup.object({
    sn: validateSn(checkSn),
    imo_nr: Yup.number()
      .nullable()
      .optional()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue == null ? undefined : value
      ),
    schiffsname: Yup.string()
      .nullable()
      .optional()
      .transform((value) =>
        typeof value === 'string' && value.trim() === '' ? undefined : value
      ),
    email: Yup.string().required('This field is required'),
    produktionsdatum: produktionsdatumRequired
      ? Yup.string().required('This field is required')
      : Yup.number().optional(),
    commissioning_date: Yup.string().required('This field is required'),
    pin: pinRequired
      ? Yup.string().required('This field is required')
      : Yup.number().optional(),
    sn_partner: Yup.number().optional(),
  });

export const originalValidationSchemeAgent = (
  checkSn: (
    value: number,
    p: TestContext<AnyObject>
  ) => Promise<boolean | ValidationError>,
  produktionsdatumRequired: boolean,
  pinRequired: boolean
) =>
  Yup.object({
    sn: validateSn(checkSn),
    sn_partner: Yup.number().optional(),
    pin: pinRequired
      ? Yup.string().required('This field is required')
      : Yup.number().optional(),
    produktionsdatum: produktionsdatumRequired
      ? Yup.string().required('This field is required')
      : Yup.number().optional(),
    imo_nr: Yup.number()
      .nullable()
      .optional()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue == null ? undefined : value
      ),
    schiffsname: Yup.string()
      .nullable()
      .optional()
      .transform((value) =>
        typeof value === 'string' && value.trim() === '' ? undefined : value
      ),
    commissioning_date: Yup.string().required('This field is required'),
  });
